// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NQyn","rightAdornment":"Header_rightAdornment__2l8ME"};